import * as S from "./plans.style";
import { TogglePlan } from "./togglePlan";
import Loader from "~/components/ui/Loader";
import PlanCard from "./planCard";
import { usePlansList } from "~/hooks/usePlansList";
import { useTranslation } from "react-i18next";
import { Fragment} from "react";

type Props = {
  closeModal?: () => void;
  initialIsAnnual?: boolean;
};

export const Plans = ({ closeModal, initialIsAnnual = false }: Props) => {
  const { t } = useTranslation();

  const {
    isLoading,
    isAnnual,
    biggestMonthsOff,
    filteredPlans,
    toggleControl,
    account,
    highestPricePlan
  } = usePlansList({ initialIsAnnual });

  if (isLoading) return <Loader />;

  return (
    <Fragment>
      <S.PageTitle>{t("settings.choose_plan")}</S.PageTitle>

      <TogglePlan
        isAnnual={isAnnual}
        toggleControl={toggleControl}
        biggestMonthsOff={biggestMonthsOff}
      />

      <S.PlansGrid
        isAnnual={isAnnual}
        columnGap={closeModal === undefined ? 1 : 2}>
        {filteredPlans?.map((plan, index) => {
          return (
            <PlanCard
              account={account}
              key={plan.id}
              plan={plan}
              closeModal={closeModal}
              isHighestPrice={plan.id === highestPricePlan?.id}
              previousPlanName={plan.previousPlanName as string}
            />
          );
        })}
      </S.PlansGrid>
    </Fragment>
  );
};
